export default {
  price: {
    en: 'Price:',
  },
}
